const pendingMeasurements = new Map();
let measurementFrame = null;

function restoreStyles(snapshots) {
    snapshots.forEach(({ element, present, value }) => {
        if (present) {
            element.setAttribute('style', value);
        } else {
            element.removeAttribute('style');
        }
    });
}

function measure(jobs) {
    const snapshots = jobs.flatMap(({ chips }) => chips.map((element) => ({
        element,
        present: element.hasAttribute('style'),
        value: element.getAttribute('style'),
    })));
    const containerWidths = jobs.map(({ container }) => container.offsetWidth);

    try {
        snapshots.forEach(({ element }) => {
            element.style.visibility = 'hidden';
            element.style.position = 'absolute';
            element.style.display = 'flex';
        });
        return jobs.map(({ chips }, index) => ({
            containerWidth: containerWidths[index],
            chipWidths: chips.map((chip) => chip.offsetWidth),
        }));
    } finally {
        restoreStyles(snapshots);
    }
}

function flushMeasurements() {
    measurementFrame = null;
    const jobs = Array.from(pendingMeasurements.values()).filter(({ canceled, container }) => !canceled && container.isConnected);
    pendingMeasurements.clear();
    if (jobs.length === 0) return;

    let measurements;
    let measurementError = null;
    const run = () => {
        try {
            measurements = measure(jobs);
        } catch (error) {
            measurementError = error;
        }
    };
    if (window.Alpine?.mutateDom) {
        window.Alpine.mutateDom(run);
    } else {
        run();
    }
    if (measurementError) throw measurementError;
    let callbackError = null;
    jobs.forEach((job, index) => {
        if (job.canceled) return;
        try {
            job.onMeasured(measurements[index]);
        } catch (error) {
            callbackError = callbackError || error;
        }
    });
    if (callbackError) throw callbackError;
}

export function scheduleLanguageOverflowMeasurement(container, chips, onMeasured) {
    const job = {
        container,
        chips: Array.from(chips),
        onMeasured,
        canceled: false,
    };
    const previous = pendingMeasurements.get(container);
    if (previous) previous.canceled = true;
    pendingMeasurements.set(container, job);

    if (measurementFrame === null) {
        measurementFrame = window.requestAnimationFrame(flushMeasurements);
    }

    return () => {
        if (job.canceled) return;
        job.canceled = true;
        if (pendingMeasurements.get(container) === job) pendingMeasurements.delete(container);
        if (pendingMeasurements.size === 0 && measurementFrame !== null) {
            window.cancelAnimationFrame(measurementFrame);
            measurementFrame = null;
        }
    };
}
